<template>
	<div>
		<app-tab/>
		<section
			:class="[
				'menu-container-hide', 'd-flex',
			]"
			>
			<div
				class="menu-btn-container d-flex align-center justify-center"
				:style="`color:${globalColors.primary};background-color:${globalColors.border}`"
				@click="toogleMenu"
			>
				<p class="menu-btn-text">Categorías</p>
			</div>
				<transition name="lateral" mode="out-in">
					<menu-web :categories="eCategories" v-if="show" class="menu-cat-hide"/>
				</transition>
		</section>
		<section>
			<h1 class="category-title" v-if="currentFilter">{{currentFilter.title}}</h1>
			<div class="section-product">
				<div>
					<el-pagination
						class="txt-right"
						layout="prev, pager, next"
						:total="totalPage"
						:page-size="limit"
						:current-page="currentPage"
						@current-change="pageChange"
					/>
				</div>
				<products-categories
					:products="listFilters"
					class="mb-3"
					v-loading="loading"
				/>
			</div>
		</section>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import productsCategories from '@/components/productsCategories';
import menuWeb from '@/components/menuWeb';
import appTab from '@/components/tab';

function created() {
	this.loadProducts();
	this.loadData();
}

async function loadProducts() {
	this.loading = true;
	const publicUrl = 'products-public';
	const privateUrl = 'products/favorites';
	const url = this.token ? privateUrl : publicUrl;
	const privateHeaders = {
		Authorization: `Bearer ${this.token}`,
	};
	const params = {
		filters: this.id,
		page: this.currentPage,
	};
	const headers = this.token ? privateHeaders : null;
	const response = await this.$httpQtc.get(url, { headers, params });
	this.totalPage = Number(response.headers['x-quantity']);
	this.listFilters = response.data;
	this.loading = false;
	this.showFilters = true;
	this.currentFilter = this.filters.filter(f => f.id === this.id)[0];
}

function pageChange(newPage) {
	this.currentPage = newPage;
	this.loadProducts();
}

async function loadData() {
	const params = {
		commerceId: this.getCommerceData.id,
	};
	const requests = [
		this.$httpQtc.get('e-categories-public', { params }),
		this.$httpQtc.get('filters-public'),
	];
	([
		{ data: this.eCategories },
		{ data: this.filters },
	] = await Promise.all(requests));
	this.currentFilter = this.filters.filter(f => f.id === this.id)[0];
}

function toogleMenu() {
	this.show = !this.show;
}

function selectFilter({ id }) {
	this.currentPage = 1;
	this.$router.push({ name: 'filters', params: { id } });
}

function getOptions() {
	if (this.filters.length >= 6) {
		return this.swiperOption;
	}

	if (this.filters.length >= 5) {
		return this.swiperOptionOne;
	}

	if (this.filters.length >= 4) {
		return this.swiperOptionTwo;
	}
	return this.swiperOptionThree;
}

function nextSlider() {
	this.swiper.slideNext();
}

function prevSlider() {
	this.swiper.slidePrev();
}

function swiper() {
	return this.$refs.mySwiper.swiper;
}

function data() {
	return {
		currentFilter: null,
		currentPage: 1,
		eCategories: [],
		filters: [],
		limit: 10,
		listFilters: [],
		loading: false,
		show: false,
		showFilters: false,
		swiperOption: {
			slidesPerView: 6,
			spaceBetween: 0,
			breakpoints: {
				900: {
					slidesPerView: 5,
				},
				835: {
					slidesPerView: 4,
				},
				680: {
					slidesPerView: 3,
				},
				558: {
					slidesPerView: 2,
				},
			},
		},
		swiperOptionOne: {
			slidesPerView: 5,
			spaceBetween: 0,
			breakpoints: {
				835: {
					slidesPerView: 4,
				},
				680: {
					slidesPerView: 3,
				},
				558: {
					slidesPerView: 2,
				},
			},
		},
		swiperOptionTwo: {
			slidesPerView: 4,
			spaceBetween: 0,
			breakpoints: {
				680: {
					slidesPerView: 3,
				},
				558: {
					slidesPerView: 2,
				},
			},
		},
		swiperOptionThree: {
			slidesPerView: 3,
			spaceBetween: 0,
			breakpoints: {
				558: {
					slidesPerView: 2,
				},
			},
		},
		totalPage: 0,
	};
}

export default {
	name: 'Filters',
	components: {
		appTab,
		menuWeb,
		productsCategories,
	},
	computed: {
		...mapGetters([
			'getCommerceData',
			'token',
		]),
		getOptions,
		swiper,
	},
	created,
	data,
	methods: {
		loadData,
		loadProducts,
		nextSlider,
		pageChange,
		prevSlider,
		selectFilter,
		toogleMenu,
	},
	props: {
		id: [Number, String],
	},
	watch: {
		$route: loadProducts,
	},
};
</script>
<style lang="scss" scoped>

	.menu-container-hide {
		background-color: white;
		cursor: pointer;
		height: 42.7rem;
		left: 0%;
		margin-top: 6rem;
		position: absolute;
		top: 0;
		transition: right 200ms ease-in;
		z-index: 2;

		@media (max-width: 600px) {
			display: none;
		}
	}

	.menu-btn-container {
		font-family: font(avenirBold);
		font-size: size(msmall);
		width: 3rem;
		z-index: 9;
	}

	.menu-btn-text {
		transform: rotateZ(270deg);
	}

	.section-product {
		margin: 0 auto;
		max-width: 102.4rem;
	}

	.category-title {
		border-bottom: 0.2rem solid color(textGrey);
		font-family: font(avenirBold);
		font-size: size(maxsmall);
		margin: 1rem auto 3.5rem;
		max-width: 102.4rem;
		padding: 3rem 1rem 1rem;	
	}

	.menu-cat-hide {
		box-shadow: 6px 8px 8px -6px rgba(0, 0, 0, 0.11);
		width: 26rem;
	}

	.wrapper-filters {
		background: color(white);
		height: 6rem;
		padding: 0 12.7rem;
		position: relative;
		z-index: 3;

		@media (max-width: 600px) {
			padding: 0 10%;
		}
	}
	
	.container-buttons-slider {
		display: flex;
		justify-content: space-between;
		left: 0;
		padding: 0 5.2rem;
		position: absolute;
		top: 1.4rem;
		width: 100%;

		@media (max-width: 600px) {
			padding: 0 6%;
		}
	}

	.btn-slider {
		background: transparent;
		border: none;
		display: block;
		height: 6rem;
		font-family: font(avenirBold);
		font-size: size(medium);
		width: 100%;
	}

	.btn {
		background: transparent;
		border: none;
		outline: none;
	}

	.wrapper-buttons {
		flex: 1 1 auto;
	}

	.wrapper-filters-min {
		display: flex;
		position: relative;
		z-index: 5;
	}
</style>


// WEBPACK FOOTER //
// Filters.vue?241b6178